module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("At The Sign Of The Golden Pineapple")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("M. C. Beaton/ Marion Chesney")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4df803c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795320729_epub_tp_r1.vue
// module id = 60
// module chunks = 0